import React from "react";
import { Colors } from "./colors";

class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      type: props.type || "text",
      isFocused: false,
      failed: props.isfailed || false,
    };
  }

  componentDidUpdate(prevProps) {
    
    // Check if the prop has changed
      if (this.props.value !== prevProps.value) {
    this.setState({ value: this.props.value });
    }

    if (this.props.isfailed !== prevProps.isfailed) {
      // Update the state with the new prop value
      this.setState({
        failed: true,
      });
    }
  }
  handleFocus = () => {
    this.setState({ isFocused: true, failed: false });
  };

  handleBlur = () => {
    this.setState({ isFocused: false, failed: this.props.isfailed });
  };

  handleChange = (event) => {
    const { func } = this.props;
    this.setState({ value: event.target.value });
    func(event.target.value);
  };

  render() {
    const { value, failed, isFocused, type } = this.state;
    const { placeholder, style, readOnly } = this.props;

    const inputStyle = {
      padding: "8px",
      margin: failed || isFocused ? "8px": '11px',
      width: "100%",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      outline: "none",
      borderWidth: failed || isFocused ? "4px" : "1px",
      borderColor: isFocused
        ? Colors.lightBlue
        : failed
          ? Colors.brightRed
          : "#ccc",
      transition: "0.1s ease",
      flex: this.props.ratio,
    };

    return (
      <input
        type={type}
        style={{ ...inputStyle, ...style }}
        value={value}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onInput={this.handleChange}
        placeholder={placeholder}
        onKeyDown={this.props.onKeyDown || (() => {})}
      />
    );
  }
}

export default TextInput;
